import { Col, Form, Row } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import AdnCard from "../common/adnCard/AdnCard";
import AdnFormOptions from "../common/adnFormOptions/AdnFormOptions";
import AdnInput from "../common/adnInput/AdnInput";
import AdnPageTitle from "../common/adnPageTitle/AdnPageTitle";
import AdnTextArea from "../common/adnTextArea/AdnTextArea";

export const WhatsappGroupForm = ({
  form,
  initValues,
  title,
  handleFinish,
  handleCancel,
  loading,
  submitLoading,
}) => {
  const { t } = useTranslation();

  const nameRules = [
    {
      required: true,
      message: t("whatsappGroup.whatsappGroupForm.validation.nameRequired"),
    },
    {
      max: 45,
      message: t("whatsappGroup.whatsappGroupForm.validation.nameMaxLength"),
    },
    {
      pattern: /^((?!#ADN4).)*$/,
      message: t(
        "whatsappGroup.whatsappGroupForm.validation.nameInvalidExpression"
      ),
    },
  ];

  const noteRules = [
    {
      required: true,
      message: t("whatsappGroup.whatsappGroupForm.validation.noteRequired"),
    },
    {
      max: 200,
      message: t("whatsappGroup.whatsappGroupForm.validation.noteMaxLength"),
    },
    {
      min: 2,
      message: t("whatsappGroup.whatsappGroupForm.validation.noteMinLength"),
    },
  ];

  const linkRules = [
    {
      required: true,
      message: t("whatsappGroup.whatsappGroupForm.validation.linkRequired"),
    },
    {
      max: 34,
      message: t("whatsappGroup.whatsappGroupForm.validation.linkMaxLength"),
    },
    {
      pattern: /^[a-zA-Z0-9]*$/,
      message: t(
        "whatsappGroup.whatsappGroupForm.validation.linkOnlyAlphanumeric"
      ),
    },
  ];

  return (
    <>
      <AdnPageTitle title={title} />

      <AdnCard loading={loading}>
        <Form
          form={form}
          name="advanced_search"
          layout="vertical"
          className="ant-advanced-search-form"
          onFinish={handleFinish}
          initialValues={initValues}
        >
          <Row key={"name"}>
            <Col span={24}>
              <AdnInput
                name={"name"}
                label={t("whatsappGroup.whatsappGroupForm.labels.name")}
                rules={nameRules}
                maxLength={45}
                addonBefore={"#ADN4"}
              />
            </Col>
          </Row>

          <Row key={"note"}>
            <Col span={24}>
              <AdnTextArea
                name={"note"}
                label={t("whatsappGroup.whatsappGroupForm.labels.note")}
                rules={noteRules}
                maxLength={200}
                rows={2}
                showCount={true}
              />
            </Col>
          </Row>

          <Row key={"noteEN"}>
            <Col span={24}>
              <AdnTextArea
                name={"noteEN"}
                label={t("whatsappGroup.whatsappGroupForm.labels.noteEN")}
                rules={noteRules}
                maxLength={200}
                rows={2}
                showCount={true}
              />
            </Col>
          </Row>

          <Row key={"link"}>
            <Col span={24}>
              <AdnInput
                name={"link"}
                label={t("whatsappGroup.whatsappGroupForm.labels.link")}
                rules={linkRules}
                maxLength={34}
                addonBefore={"https://chat.whatsapp.com/"}
              />
            </Col>
          </Row>

          <AdnFormOptions handleCancel={handleCancel} loading={submitLoading} />
        </Form>
      </AdnCard>
    </>
  );
};
